<template>
    <div>
        <h2 class="mb-1">Peer Services Discharge Report</h2>
        
        <div style="display: flex; flex-wrap: wrap; align-items: center;" class="mb-2">
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon mr-50"
                style="height: 37px; margin-top: 12px;"
                @click.stop.prevent="prevRange()"
            >
                <feather-icon icon="ChevronLeftIcon" />
            </b-button>

            <b-form-group
                label="Start Date"
                class="mr-50 w-10"
            >
                <date-picker v-model="startDate" type="month" format="MM-DD-YYYY" value-type="DD/MM/YYYY" v-if="selectedRangeDate === 'month' || selectedRangeDate === 'quarter'"></date-picker>
                <date-picker v-model="startDate" type="year" format="MM-DD-YYYY" value-type="DD/MM/YYYY" v-else-if="selectedRangeDate === 'year'"></date-picker>
                <date-picker v-model="startDate" type="date" format="MM-DD-YYYY" value-type="DD/MM/YYYY" v-else-if="!selectedRangeDate || selectedRangeDate === 'custom'"></date-picker>
            </b-form-group>
        
            <b-form-group
                label="End Date"
                class="mr-50"
            >
                <date-picker v-model="endDate" type="date" format="MM-DD-YYYY" value-type="DD/MM/YYYY" :disabled="selectedRangeDate === 'month' || selectedRangeDate === 'quarter' || selectedRangeDate === 'year' ? true : false"></date-picker>
            </b-form-group>

            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon ml-0"
                style="height: 37px; margin-top: 12px;"
                @click.stop.prevent="nextRange()"
            >
                <feather-icon icon="ChevronRightIcon" />
            </b-button>
            
            <div :class="!selectedRangeDate ? 'pl-1' : 'pl-1'">
                <b-form-group>
                    <b-form-radio-group
                        v-model="selectedRangeDate"
                        button-variant="outline-primary range-date"
                        buttons
                        class="p-0 mr-2"
                    >
                        <b-form-radio style="height: 37px; padding: 11px;" v-for="(option,index) in optionsRangeDate" :key="index + makeid(6)" :value="option.value">{{option.text}}</b-form-radio>
                        <b-form-radio style="height: 37px; padding: 10px;" v-if="selectedRangeDate" value="x">x</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
            
            <b-form-group label="Discharge Status">
                <v-select
                    v-model="filterDischargeStatus"
                    placeholder="Discharge Status"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="psdfStatusOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Discharge Disposition">
                <v-select
                    v-model="filterDischargeDisposition"
                    placeholder="Discharge Disposition"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="psdfDispositionOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Referral Disposition">
                <v-select
                    v-model="filterReferralDisposition"
                    placeholder="Referral Disposition"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="psdfReferralDispositionOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Gambling Comparison">
                <v-select
                    v-model="filterGamblingComparison"
                    placeholder="Gambling Comparison"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="psdfGamblingComparisonOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Self-Help at Discharge">
                <v-select
                    v-model="filterSelfHelp"
                    placeholder="Self-Help at Discharge"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="psdfSelfHelpOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Continued Services">
                <v-select
                    v-model="filterContinuedServices"
                    placeholder="Continued Services"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="psdfContinuedServicesOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Problem Status - Gambling">
                <v-select
                    v-model="filterProblemGambling"
                    placeholder="Problem Status - Gambling"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="psdfProblemStatusOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Problem Status - Drug Use">
                <v-select
                    v-model="filterProblemDrug"
                    placeholder="Problem Status - Drug Use"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="psdfProblemStatusOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Problem Status - Alcohol Use">
                <v-select
                    v-model="filterProblemAlcohol"
                    placeholder="Problem Status - Alcohol Use"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="psdfProblemStatusOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Problem Status - Financial">
                <v-select
                    v-model="filterProblemFinancial"
                    placeholder="Problem Status - Financial"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="psdfProblemStatusOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Problem Status - Legal">
                <v-select
                    v-model="filterProblemLegal"
                    placeholder="Problem Status - Legal"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="psdfProblemStatusOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Problem Status - Vocational">
                <v-select
                    v-model="filterProblemVocational"
                    placeholder="Problem Status - Vocational"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="psdfProblemStatusOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Problem Status - Medical">
                <v-select
                    v-model="filterProblemMedical"
                    placeholder="Problem Status - Medical"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="psdfProblemStatusOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Problem Status - Lethality Self">
                <v-select
                    v-model="filterProblemLethalitySelf"
                    placeholder="Problem Status - Lethality Self"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="psdfProblemStatusOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Problem Status - Lethality Other">
                <v-select
                    v-model="filterProblemLethalityOther"
                    placeholder="Problem Status - Lethality Other"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="psdfProblemStatusOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Problem Status - Mental Health">
                <v-select
                    v-model="filterProblemMental"
                    placeholder="Problem Status - Mental Health"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="psdfProblemStatusOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Problem Status - Family">
                <v-select
                    v-model="filterProblemFamily"
                    placeholder="Problem Status - Family"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="psdfProblemStatusOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <div>
                <b-button
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="flat-primary"
                    class="mb-1 mt-2 p-75"
                    @click="resetFilters"
                >
                    <feather-icon
                        icon="XIcon"
                        class="mr-50"
                    />
                    <span class="align-middle">Reset filters</span>
                </b-button>
            </div>
        </div>

        <b-card>
            <h5>Peer Services Discharge Forms</h5>
            <hr>
            <b-row>
                <!-- Total Forms -->
                <b-col lg="3" md="3" sm="12">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ totalDischargeForms }}
                                </h2>
                                <span>Total Discharge Forms</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Discharge Status -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in psdfStatusOptions" :key="'status-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Discharge Status') }}
                                </h2>
                                <span>Discharge Status / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Discharge Disposition -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in psdfDispositionOptions" :key="'disposition-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Discharge Disposition') }}
                                </h2>
                                <span>Discharge Disposition / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Referral Disposition -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in psdfReferralDispositionOptions" :key="'referral-disp-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Referral Disposition') }}
                                </h2>
                                <span>Referral Disposition / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Gambling Comparison -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in psdfGamblingComparisonOptions" :key="'gambling-comp-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Gambling Comparison') }}
                                </h2>
                                <span>Gambling Comparison / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Self Help -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in psdfSelfHelpOptions" :key="'self-help-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Self-Help at Discharge') }}
                                </h2>
                                <span>Self-Help at Discharge / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Continued Services -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in psdfContinuedServicesOptions" :key="'continued-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Continued Services') }}
                                </h2>
                                <span>Continued Services / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Problem Status - Gambling -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in psdfProblemStatusOptions" :key="'prob-gambling-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Problem Status - Gambling') }}
                                </h2>
                                <span>Problem Status - Gambling / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Problem Status - Drug Use -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in psdfProblemStatusOptions" :key="'prob-drug-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Problem Status - Drug Use') }}
                                </h2>
                                <span>Problem Status - Drug Use / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Problem Status - Alcohol Use -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in psdfProblemStatusOptions" :key="'prob-alcohol-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Problem Status - Alcohol Use') }}
                                </h2>
                                <span>Problem Status - Alcohol Use / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Problem Status - Financial -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in psdfProblemStatusOptions" :key="'prob-financial-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Problem Status - Financial') }}
                                </h2>
                                <span>Problem Status - Financial / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Problem Status - Legal -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in psdfProblemStatusOptions" :key="'prob-legal-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Problem Status - Legal') }}
                                </h2>
                                <span>Problem Status - Legal / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Problem Status - Vocational -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in psdfProblemStatusOptions" :key="'prob-vocational-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Problem Status - Vocational') }}
                                </h2>
                                <span>Problem Status - Vocational / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Problem Status - Medical -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in psdfProblemStatusOptions" :key="'prob-medical-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Problem Status - Medical') }}
                                </h2>
                                <span>Problem Status - Medical / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Problem Status - Lethality Self -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in psdfProblemStatusOptions" :key="'prob-lethality-self-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Problem Status - Lethality Self') }}
                                </h2>
                                <span>Problem Status - Lethality Self / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Problem Status - Lethality Other -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in psdfProblemStatusOptions" :key="'prob-lethality-other-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Problem Status - Lethality Other') }}
                                </h2>
                                <span>Problem Status - Lethality Other / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Problem Status - Mental Health -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in psdfProblemStatusOptions" :key="'prob-mental-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Problem Status - Mental Health') }}
                                </h2>
                                <span>Problem Status - Mental Health / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Problem Status - Family -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in psdfProblemStatusOptions" :key="'prob-family-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Problem Status - Family') }}
                                </h2>
                                <span>Problem Status - Family / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </b-card>

        <download-csv 
            :data="jsonData"
            class="mb-1 btn btn-default"
            name="peer-services-discharge-report.csv"
            :style="readyToExport ? 'background: #94221e; color: #fff; cursor: pointer; opacity: 1;' : 'background: #94221e; color: #fff; cursor: no-drop; opacity: 0.5;'"
            delimiter=","
            v-if="isDataSpecialist"
        >
            CSV Export
            <b-spinner small v-if="!readyToExport" />
        </download-csv>
    </div>
</template>

<script>
import { 
    BButton, BRow, BCol, BFormGroup, BCard, BCardBody, BSpinner, BFormRadioGroup, BFormRadio
} from 'bootstrap-vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import moment from 'moment'
import { db, auth } from '@/firebase'

export default {
    data() {
        return {
            // Date filters
            startDate: null,
            endDate: null,
            selectedRangeDate: 'month',
            optionsRangeDate: [
            { text: 'Month', value: 'month' },
            { text: 'Quarter', value: 'quarter' },
            { text: 'Year', value: 'year' },
            { text: 'Custom', value: 'custom' },
            ],
            rangeDinamic: false,

            // Filters
            filterDischargeStatus: '',
            filterDischargeDisposition: '',
            filterReferralDisposition: '',
            filterGamblingComparison: '',
            filterSelfHelp: '',
            filterContinuedServices: '',
            filterProblemGambling: '',
            filterProblemDrug: '',
            filterProblemAlcohol: '',
            filterProblemFinancial: '',
            filterProblemLegal: '',
            filterProblemVocational: '',
            filterProblemMedical: '',
            filterProblemLethalitySelf: '',
            filterProblemLethalityOther: '',
            filterProblemMental: '',
            filterProblemFamily: '',

            // Data
            totalDischargeForms: 0,
            arrayResults: [],
            filteredData: [],
            jsonData: [],
            
            // Loading states
            isBusy: true,
            isDataSpecialist: false,
            readyToExport: false,

            // Options
            psdfStatusOptions: [
                'Completed Peer Services, All Goals Met',
                'Completed Peer Services, Half or More Goals Met',
                'Completed Peer Services, Some Goals Met',
                'Unplanned Discharge'
            ],
            psdfDispositionOptions: [
                'Additional services at this level of care no longer necessary',
                'Further services at this level of care unlikely to yield additional gains',
                'Client chose to discontinue services',
                'Formal referral made/offered',
                'Lost contact, No referral possible',
                'Termination of third party funds',
                'Discharged due to non-compliance, Program Rules',
                'Discharged due to non-compliance, Violence',
                'Client arrested/incarcerated',
                'Client could no longer participate for medical/psychiatric reasons',
                'Client death',
                'Client relocated',
                'Program closed'
            ],
            psdfReferralDispositionOptions: [
                'No referral made',
                'Client not in need of additional services',
                'Client referred to SUD program',
                'Client referred to mental health program',
                'Client referred to other problem gambling program',
                'Client refused referral'
            ],
            psdfGamblingComparisonOptions: [
                'N/A',
                'No longer gambling',
                'Reduced gambling',
                'Same gambling',
                'Worse gambling'
            ],
            psdfSelfHelpOptions: [
                'Yes',
                'No',
                'N/A'
            ],
            psdfContinuedServicesOptions: [
                'Problem Gambling Self-Help Group Meetings',
                'Substance Use Self-Help Group Meetings',
                'Financial Counseling',
                'Crisis Services',
                'Problem Gambling Treatment Services',
                'Substance Use Treatment Services',
                'Recovery Support Services',
                'N/A'
            ],
            psdfTreatmentOptions: [
                'Inpatient Rehabilitation',
                'Residential',
                'Outpatient'
            ],
            psdfRecoveryServicesOptions: [
                'Recovery Community and Outreach Center',
                'Youth Clubhouse',
                'Peer Advocate',
                'Open Access Center',
                'Family Navigator',
                'Regional Addiction Resource Center',
                'Other'
            ],
            psdfProblemStatusOptions: [
                'Achieved',
                'Partial Achievement',
                'Not Achieved',
                'Not Applicable'
            ]
        }
    },
    components: {
        BButton, BRow, BCol, BFormGroup, BCard, BCardBody, BSpinner, BFormRadioGroup, BFormRadio,
        DatePicker, vSelect
    },
    directives: {
        Ripple,
    },
    watch: {
        selectedRangeDate(val) {
            this.functionDateRange(val)
        },
        startDate(val) {
            if(val) {
                this.isBusy = true
                this.functionDateRange(this.selectedRangeDate)
                this.rangeDinamic ? this.rangeDinamic = false : ''
                this.applyFilters()
            }
        },
        endDate(val) {
            if(val) {
                this.isBusy = true
                this.applyFilters()
            }
        },
        filterDischargeStatus() { this.applyFilters() },
        filterDischargeDisposition() { this.applyFilters() },
        filterReferralDisposition() { this.applyFilters() },
        filterGamblingComparison() { this.applyFilters() },
        filterSelfHelp() { this.applyFilters() },
        filterContinuedServices() { this.applyFilters() },
        filterProblemGambling() { this.applyFilters() },
        filterProblemDrug() { this.applyFilters() },
        filterProblemAlcohol() { this.applyFilters() },
        filterProblemFinancial() { this.applyFilters() },
        filterProblemLegal() { this.applyFilters() },
        filterProblemVocational() { this.applyFilters() },
        filterProblemMedical() { this.applyFilters() },
        filterProblemLethalitySelf() { this.applyFilters() },
        filterProblemLethalityOther() { this.applyFilters() },
        filterProblemMental() { this.applyFilters() },
        filterProblemFamily() { this.applyFilters() }
    },
    methods: {
        makeid(length) {
            var result = '';
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for(var i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        },
        getCounter(payload, type) {
            var filterResult = this.arrayResults.filter(ele => ele.text === payload && ele.type === type)
            if(filterResult.length) {
                return filterResult[0].count
            } else {
                return 0
            }
        },
        resetFilters() {
            this.startDate = null
            this.endDate = null
            this.filterDischargeStatus = ''
            this.filterDischargeDisposition = ''
            this.filterReferralDisposition = ''
            this.filterGamblingComparison = ''
            this.filterSelfHelp = ''
            this.filterContinuedServices = ''
            this.filterProblemGambling = ''
            this.filterProblemDrug = ''
            this.filterProblemAlcohol = ''
            this.filterProblemFinancial = ''
            this.filterProblemLegal = ''
            this.filterProblemVocational = ''
            this.filterProblemMedical = ''
            this.filterProblemLethalitySelf = ''
            this.filterProblemLethalityOther = ''
            this.filterProblemMental = ''
            this.filterProblemFamily = ''
        },
        functionDateRange(val) {
            if(val === 'month') {
                if(this.startDate) {
                    var formatDate1 = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                    var formatDate = moment(this.startDate,'DD/MM/YYYY').format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(1, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                } else {
                    var formatDate1 = moment(Date.now()).format('MM/DD/YYYY')
                    var formatDate = moment(Date.now()).format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(1, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                }
            } else if(val === 'quarter') {
                if(this.startDate) {
                    var formatDate1 = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                    var formatDate = moment(this.startDate,'DD/MM/YYYY').format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(3, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                } else {
                    var formatDate1 = moment(Date.now()).format('MM/DD/YYYY')
                    var formatDate = moment(Date.now()).format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(3, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                }
            } else if(val === 'year') {
                if(this.startDate) {
                    var formatDateNew = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                    var getYear = moment(formatDateNew).format('YYYY')
                    var formatDate1 = moment('01/01/'+getYear).format('MM/DD/YYYY')
                    var formatDate = '01/01/'+getYear
                    var expiredDate = moment(formatDate1).add(12, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                } else {
                    var getYear = moment(Date.now()).format('YYYY')
                    var formatDate1 = moment('01/01/'+getYear).format('MM/DD/YYYY')
                    var formatDate = moment('01/01/'+getYear).format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(12, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                }
            } else if(val === 'x') {
                this.selectedRangeDate = ''
                this.startDate = null
                this.endDate = null
            }
        },
        prevRange() {
            if(this.startDate && this.selectedRangeDate) {
                var formatDate = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                var subtractDate = moment(formatDate).subtract(1, 'months')
                var dateUpdateFormat = moment(subtractDate,'MM/DD/YYYY').format('DD/MM/YYYY')

                this.rangeDinamic = true
                this.startDate = dateUpdateFormat
                this.functionDateRange(this.selectedRangeDate)
            }
        },
        nextRange() {
            if(this.startDate && this.selectedRangeDate) {
                var formatDate = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                var subtractDate = moment(formatDate).add(1, 'months')
                var dateUpdateFormat = moment(subtractDate,'MM/DD/YYYY').format('DD/MM/YYYY')

                this.rangeDinamic = true
                this.startDate = dateUpdateFormat
                this.functionDateRange(this.selectedRangeDate)
            }
        },
        applyFilters() {
            this.isBusy = true
            
            // Reset counters
            this.arrayResults.forEach(ele => {
                ele.count = 0
            })

            let filtered = [...this.filteredData]

            // Date filter
            if(this.startDate && this.endDate) {
                filtered = filtered.filter(item => {
                    if(!item.psdfDate) return false
                    const itemDate = moment(item.psdfDate, 'MM-DD-YYYY')
                    const start = moment(this.startDate, 'DD/MM/YYYY')
                    const end = moment(this.endDate, 'DD/MM/YYYY')
                    return itemDate.isBetween(start, end, null, '[]')
                })
            }

            // Apply all filters
            if(this.filterDischargeStatus) {
                filtered = filtered.filter(item => item.psdfStatus === this.filterDischargeStatus)
            }
            if(this.filterDischargeDisposition) {
                filtered = filtered.filter(item => item.psdfDisposition && item.psdfDisposition.includes(this.filterDischargeDisposition))
            }
            if(this.filterReferralDisposition) {
                filtered = filtered.filter(item => item.psdfReferralDisposition && item.psdfReferralDisposition.includes(this.filterReferralDisposition))
            }
            if(this.filterGamblingComparison) {
                filtered = filtered.filter(item => item.psdfGamblingComparison === this.filterGamblingComparison)
            }
            if(this.filterSelfHelp) {
                filtered = filtered.filter(item => item.psdfSelfHelp === this.filterSelfHelp)
            }
            if(this.filterContinuedServices) {
                filtered = filtered.filter(item => item.psdfContinuedServices && item.psdfContinuedServices.includes(this.filterContinuedServices))
            }
            if(this.filterProblemGambling) {
                filtered = filtered.filter(item => item.psdfProblemGambling === this.filterProblemGambling)
            }
            if(this.filterProblemDrug) {
                filtered = filtered.filter(item => item.psdfProblemDrug === this.filterProblemDrug)
            }
            if(this.filterProblemAlcohol) {
                filtered = filtered.filter(item => item.psdfProblemAlcohol === this.filterProblemAlcohol)
            }
            if(this.filterProblemFinancial) {
                filtered = filtered.filter(item => item.psdfProblemFinancial === this.filterProblemFinancial)
            }
            if(this.filterProblemLegal) {
                filtered = filtered.filter(item => item.psdfProblemLegal === this.filterProblemLegal)
            }
            if(this.filterProblemVocational) {
                filtered = filtered.filter(item => item.psdfProblemVocational === this.filterProblemVocational)
            }
            if(this.filterProblemMedical) {
                filtered = filtered.filter(item => item.psdfProblemMedical === this.filterProblemMedical)
            }
            if(this.filterProblemLethalitySelf) {
                filtered = filtered.filter(item => item.psdfProblemLethalitySelf === this.filterProblemLethalitySelf)
            }
            if(this.filterProblemLethalityOther) {
                filtered = filtered.filter(item => item.psdfProblemLethalityOther === this.filterProblemLethalityOther)
            }
            if(this.filterProblemMental) {
                filtered = filtered.filter(item => item.psdfProblemMental === this.filterProblemMental)
            }
            if(this.filterProblemFamily) {
                filtered = filtered.filter(item => item.psdfProblemFamily === this.filterProblemFamily)
            }

            // Count results
            this.totalDischargeForms = filtered.length

            filtered.forEach(item => {
                this.countField(item.psdfStatus, 'Discharge Status')
                this.countArray(item.psdfDisposition, 'Discharge Disposition')
                this.countArray(item.psdfReferralDisposition, 'Referral Disposition')
                this.countField(item.psdfGamblingComparison, 'Gambling Comparison')
                this.countField(item.psdfSelfHelp, 'Self-Help at Discharge')
                this.countArray(item.psdfContinuedServices, 'Continued Services')
                this.countField(item.psdfProblemGambling, 'Problem Status - Gambling')
                this.countField(item.psdfProblemDrug, 'Problem Status - Drug Use')
                this.countField(item.psdfProblemAlcohol, 'Problem Status - Alcohol Use')
                this.countField(item.psdfProblemFinancial, 'Problem Status - Financial')
                this.countField(item.psdfProblemLegal, 'Problem Status - Legal')
                this.countField(item.psdfProblemVocational, 'Problem Status - Vocational')
                this.countField(item.psdfProblemMedical, 'Problem Status - Medical')
                this.countField(item.psdfProblemLethalitySelf, 'Problem Status - Lethality Self')
                this.countField(item.psdfProblemLethalityOther, 'Problem Status - Lethality Other')
                this.countField(item.psdfProblemMental, 'Problem Status - Mental Health')
                this.countField(item.psdfProblemFamily, 'Problem Status - Family')
            })

            // Prepare CSV export
            this.jsonData = filtered.map(item => ({
                clientID: item.clientID || '',
                dischargeDate: item.psdfDate || '',
                dischargeStatus: item.psdfStatus || '',
                dischargeDisposition: Array.isArray(item.psdfDisposition) ? item.psdfDisposition.join(', ') : '',
                referralDisposition: Array.isArray(item.psdfReferralDisposition) ? item.psdfReferralDisposition.join(', ') : '',
                sessionsAttended: item.psdfSessionsAttended || '',
                gamblingComparison: item.psdfGamblingComparison || '',
                selfHelp: item.psdfSelfHelp || '',
                continuedServices: Array.isArray(item.psdfContinuedServices) ? item.psdfContinuedServices.join(', ') : '',
                problemGambling: item.psdfProblemGambling || '',
                problemDrug: item.psdfProblemDrug || '',
                problemAlcohol: item.psdfProblemAlcohol || '',
                problemFinancial: item.psdfProblemFinancial || '',
                problemLegal: item.psdfProblemLegal || '',
                problemVocational: item.psdfProblemVocational || '',
                problemMedical: item.psdfProblemMedical || '',
                problemLethalitySelf: item.psdfProblemLethalitySelf || '',
                problemLethalityOther: item.psdfProblemLethalityOther || '',
                problemMental: item.psdfProblemMental || '',
                problemFamily: item.psdfProblemFamily || ''
            }))

            this.readyToExport = true
            this.isBusy = false
        },
        countField(value, type) {
            if(!value) return
            const filter = this.arrayResults.filter(ele => ele.text === value && ele.type === type)
            if(filter.length) {
                filter[0].count += 1
            }
        },
        countArray(values, type) {
            if(!values || !Array.isArray(values)) return
            values.forEach(value => {
                const filter = this.arrayResults.filter(ele => ele.text === value && ele.type === type)
                if(filter.length) {
                    filter[0].count += 1
                }
            })
        },
        preloadArrayResults() {
            // Limpiar array
            this.arrayResults = []

            // Precargar todas las opciones con count: 0
            this.psdfStatusOptions.forEach(opt => {
                this.arrayResults.push({text: opt, type: 'Discharge Status', count: 0})
            })
            this.psdfDispositionOptions.forEach(opt => {
                this.arrayResults.push({text: opt, type: 'Discharge Disposition', count: 0})
            })
            this.psdfReferralDispositionOptions.forEach(opt => {
                this.arrayResults.push({text: opt, type: 'Referral Disposition', count: 0})
            })
            this.psdfGamblingComparisonOptions.forEach(opt => {
                this.arrayResults.push({text: opt, type: 'Gambling Comparison', count: 0})
            })
            this.psdfSelfHelpOptions.forEach(opt => {
                this.arrayResults.push({text: opt, type: 'Self-Help at Discharge', count: 0})
            })
            this.psdfContinuedServicesOptions.forEach(opt => {
                this.arrayResults.push({text: opt, type: 'Continued Services', count: 0})
            })
            this.psdfProblemStatusOptions.forEach(opt => {
                this.arrayResults.push({text: opt, type: 'Problem Status - Gambling', count: 0})
            })
            this.psdfProblemStatusOptions.forEach(opt => {
                this.arrayResults.push({text: opt, type: 'Problem Status - Drug Use', count: 0})
            })
            this.psdfProblemStatusOptions.forEach(opt => {
                this.arrayResults.push({text: opt, type: 'Problem Status - Alcohol Use', count: 0})
            })
            this.psdfProblemStatusOptions.forEach(opt => {
                this.arrayResults.push({text: opt, type: 'Problem Status - Financial', count: 0})
            })
            this.psdfProblemStatusOptions.forEach(opt => {
                this.arrayResults.push({text: opt, type: 'Problem Status - Legal', count: 0})
            })
            this.psdfProblemStatusOptions.forEach(opt => {
                this.arrayResults.push({text: opt, type: 'Problem Status - Vocational', count: 0})
            })
            this.psdfProblemStatusOptions.forEach(opt => {
                this.arrayResults.push({text: opt, type: 'Problem Status - Medical', count: 0})
            })
            this.psdfProblemStatusOptions.forEach(opt => {
                this.arrayResults.push({text: opt, type: 'Problem Status - Lethality Self', count: 0})
            })
            this.psdfProblemStatusOptions.forEach(opt => {
                this.arrayResults.push({text: opt, type: 'Problem Status - Lethality Other', count: 0})
            })
            this.psdfProblemStatusOptions.forEach(opt => {
                this.arrayResults.push({text: opt, type: 'Problem Status - Mental Health', count: 0})
            })
            this.psdfProblemStatusOptions.forEach(opt => {
                this.arrayResults.push({text: opt, type: 'Problem Status - Family', count: 0})
            })

            // console.log('Array Results precargado:', this.arrayResults.length, 'items')
        }
    },
    created() {
        var user = auth.currentUser
        db.collection('usuarios').doc(user.uid).get()
        .then(doc => {
            this.isDataSpecialist = false
            if(doc.data().role === 'staff') {
                if(doc.data().permissions.includes('data specialist')) {
                    this.isDataSpecialist = true
                }
            } else if(doc.data().role === 'admin') {
                this.isDataSpecialist = true
            }
        })

        // Precargar arrayResults
        this.preloadArrayResults()

        // Load data from API
        // setTimeout(() => {
            this.$http.get('https://us-central1-nycpg-67e48.cloudfunctions.net/app/api/prod/peer-services-discharge-reports')
            .then(res => {
                this.filteredData = res.data
                this.applyFilters()
            })
        // }, 2500)
    }
}
</script>
<style>
.mx-input {
    height: 37px !important;
}
.form-control {
    background: #fff !important;
    background-color: #fff !important;
}
.range-date {
    padding: 8px;
    margin-top: 27px;
}
.vs__dropdown-option {
  white-space: normal !important;
}
.vs__dropdown-toggle {
  max-height: 38px;
}
.vs__selected-options {
  overflow: auto;
}
.vs__selected-options {
    overflow-x: hidden;
    overflow-y: hidden;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>